import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import FalconCloseButton from "components/common/falconCloseButton";
import TemplateRendererSection from "./templateRendererSection";

const TemplateViewModal = ({ show, handleClose, templateData }) => {
  const { t } = useTranslation();

  return (
    <Modal size="lg" show={show} onHide={handleClose} backdrop="static">
      <Modal.Header>
        <Modal.Title>
          {templateData?.templateName || t("templatePreview")}
        </Modal.Title>
        <FalconCloseButton onClick={handleClose} />
      </Modal.Header>

      <Modal.Body>
        <TemplateRendererSection
          sections={templateData?.sections || []}
          templateData={templateData}
          readOnly={true} // Disables editing UI
        />
      </Modal.Body>

      <Modal.Footer>
        <Button variant="falcon-default" size="sm" onClick={handleClose}>
          {t("close")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TemplateViewModal;
